<fieldset>
	<app-add-liability class="d-flex justify-content-center text-center"
		*ngFor="let liability of liabilitiesArray.controls; let i=index"
		[index]="i" 
		[liability]="liability"
		(removed)="liabilitiesArray.removeAt($event)"
		[qID]="qID"
		[displayErrors]="displayErrors"
		[displayX]="liabilitiesArray.length>1 && !liability.get('required').value">
	</app-add-liability>
	</fieldset>
	<div class="d-flex justify-content-center text-center">
			<div *ngIf="liabilitiesArray.length > 0 && liabilitiesArray.length < maxLiabilitieCount"  
				class="m-add-line-btn" 
				(click)="addLiability()" 
				role="button" tabindex="0" 
				(keypress)="simulateClick($event)">
				<span>{{"LIABILITIES.QUESTION2.BUTTON_ADD_AND_SAVE"|translate}}</span>
			</div>
			<div *ngIf="liabilitiesArray.length === 0"  
				class="m-add-line-btn" 
				(click)="addLiability()" 
				role="button" 
				tabindex="0" 
				(keypress)="simulateClick($event)"vvvvv>
				<i class="fa fa-plus" aria-hidden="true"></i>
				<span>{{"LIABILITIES.QUESTION2.BUTTON_ADD"|translate}}</span>
			</div>
	</div>
	<br/>


// WEBPACK FOOTER //
// ./src/app/liabilities-array/liabilities-array.component.html